import moment from 'moment'
import { TABLA_CDMD_TOTAL_CUPOS } from '../../../../../config/tables'
import { CodigoDeCupo } from '../../../../../models/cupo/codigoDeCupo'
import { COLUMNS } from './constantesDetalleTotalCupo'

export function parseData (data) {
  const parsedData = []
  if (data.length > 0) {
    data.map((entry) => {
      // si hay cupos del dia, existen en terminal o en viaje se muestra en la tabla.
      // if (entry.asignados > 0 || entry.enTerminal > 0 || entry.totalEnViaje > 0) {
      const posibleArribo = entry.totalEnViaje + entry.sinConsumir
      return parsedData.push({ ...entry, entry: { ...entry, posibleArribo } })
      // }
    })
  }
  return parsedData
}

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CDMD_TOTAL_CUPOS
    })
    CodigoDeCupo.getCodigoDeCupoTotalCereal()
      .then((d) => {
        const fecha = moment(new Date()).format('DD-MM-YYYY HH:mm')
        dispatch({ type: 'ACTUALIZAR_ESTADO_ARRIBO', fecha })
        const data = parseData(d)
        const customToolbar = null

        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COLUMNS,
            data: data,
            title: 'Cupos vigentes',
            isLoading: false,
            fixed2Decimales: false,
            responsive: 'vertical',
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              download: false,
              filter: false,
              search: false,
              viewColumns: false
            }
          },
          id: TABLA_CDMD_TOTAL_CUPOS
        })
      })
  }
}
